<template>
  <div class="surveyform">
    <h1 class="text-center mb-2">Add Survey Question</h1>
    <div class="flex content-center flex-wrap items-center">
      <div class="pr-5">CONTENT:</div>
      <div class="w-3/5">
        <input
          v-model="content"
          type="text"
          class="input-box-course-creators"
        />
      </div>
    </div>
    <div class="flex content-center flex-wrap items-center">
      <div class="pr-5">TITLE:</div>
      <div class="w-3/5">
        <input v-model="title" type="text" class="input-box-course-creators" />
      </div>
    </div>
    <div v-for="(item, index) in response_map" :key="index">
      <RatingCard :item="item" :index="index"></RatingCard>
    </div>
    <div class="form-group">
      <div>
        <button
          class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-2 hover:bg-green-900"
          @click="addSurveyQuestion"
        >
          Add Question
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import RatingCard from "@/components/surveyQuestion/RatingCard"

export default {
  components: {
    RatingCard,
  },
  data() {
    return {
      content: "",
      response_map: {
        "1": {
          subtitles: ["Much below my expectations.", "What went wrong?"],
          tags: [
            "Slow response",
            "Confusing explanation",
            "Impolite",
            "Irregular",
          ],
          emojiName: "emoji-frowning-face",
        },
        "2": {
          subtitles: ["Not up to my expectations.", "What went wrong?"],
          tags: [
            "Slow response",
            "Confusing explanation",
            "Impolite",
            "Irregular",
          ],
          emojiName: "emoji-neutral-face",
        },
        "3": {
          subtitles: ["Good, but can be better", "Where can we improve?"],
          tags: ["Slow response", "Explanation", "Polite"],
          emojiName: "emoji-slightly-smiling-face",
        },
        "4": {
          subtitles: ["Great! Exceeded my expectations", "What did you love?"],
          tags: ["Fast response", "Explanation", "Debugging", "Polite"],
          emojiName: "emoji-satisfied",
        },
      },
      title: "",
    }
  },
  methods: {
    validationCheck() {
      if (!this.content) {
        this.$noty.warning("Please fill the content field")
        return false
      }
      if (!this.title) {
        this.$noty.warning("Please fill the title field")
        return false
      }
      return true
    },
    addSurveyQuestion() {
      if (!this.validationCheck()) {
        return
      }
      const data = {
        content: this.content,
        title: this.title,
        response_map: this.response_map,
      }
      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}survey/questions`,
        data,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(() => {
          this.$noty.success("survey questions added successfully")
          this.$router.push({ name: "SurveyQuestionList" })
        })
        .catch(err => {
          this.$noty.error(`Failed to add the survey questions ${err}`)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.surveyform {
  max-width: 70%;
  margin: auto;
}
img {
  width: 2em;
  height: 3em;
  margin-top: -10px;
}
</style>
